import { useEffect, useState } from 'react'

const useInView = ({ ref, refUpdate }) => {
  const [inView, setInView] = useState(false)
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1
 };
 const handleObserver = (entities) => {
  const target = entities[0];
  if (target.isIntersecting) {   
    setInView(target.isIntersecting)
  }
}

  useEffect(() => {
    // initialize IntersectionObserver
    // and attaching to Pagination div
     if (ref?.current) {
       const observer = new IntersectionObserver(handleObserver, options);
        observer.observe(ref.current)
     }
  }, [ref, refUpdate])
  return { inView, setInView }
}

export default useInView

